import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Loader from "@client.components/Loader";
import NoData from "@client.components/NoData";
import "./ChartContainer.scss";

export const ChartContainer = ({
  title,
  renderTitleComponent,
  renderRightComponent,
  className,
  children,
  isLoading,
  data,
  isDataAvailable,
}) => {
  const renderContent = () => {
    const showChart = isDataAvailable ? isDataAvailable(data) : data.length > 0;
    return showChart ? children : <NoData />;
  };

  return (
    <div className={classNames("chart-container", className)}>
      <div className="header">
        <div className="title">
          {title}
          {renderTitleComponent && renderTitleComponent()}
        </div>
        {renderRightComponent && (
          <div className="right-container">{renderRightComponent()}</div>
        )}
      </div>
      <div className="chart">
        {isLoading ? <Loader loading={true} /> : renderContent()}
      </div>
    </div>
  );
};

ChartContainer.propTypes = {
  title: PropTypes.string.isRequired,
  renderTitleComponent: PropTypes.func,
  renderRightComponent: PropTypes.func,
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  data: PropTypes.array,
  isDataAvailable: PropTypes.func,
};
